import React from 'react'
import styled from 'styled-components/macro'
import SuccessHubBadge from 'src/components/growthEngine/SuccessHubBadge'

/**
 * Tasteful live-unlock receipt. P2 outcome copy (GP% already filled by
 * Express). No confetti, no fire emoji, no second walkthrough.
 */
const SuccessHubCelebration = ({
  celebration,
  className,
  'data-testid': dataTestId = 'progress-celebration',
}) => {
  if (!celebration?.outcome) return null

  return (
    <Wrap
      className={className}
      data-testid={dataTestId}
      role='status'
      aria-label={celebration.outcome}
    >
      <SuccessHubBadge
        badge={celebration.badge}
        title={celebration.displayName}
        size={36}
        data-testid={`${dataTestId}-badge`}
      />
      <Copy>
        {celebration.displayName ? (
          <Title data-testid={`${dataTestId}-title`}>
            {celebration.displayName}
          </Title>
        ) : null}
        <Outcome data-testid={`${dataTestId}-outcome`}>
          {celebration.outcome}
        </Outcome>
      </Copy>
    </Wrap>
  )
}

const Wrap = styled.aside`
  align-items: flex-start;
  display: flex;
  gap: 12px;
  padding: 4px 0 8px;
  width: 100%;
`

const Copy = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`

const Title = styled.p`
  color: ${({ theme }) => theme?.colours?.bbqBlack || '#000'};
  font-size: 13px;
  font-weight: 600;
  line-height: 1.35;
  margin: 0;
`

const Outcome = styled.p`
  color: ${({ theme }) => theme?.colours?.seaweedGreen || '#132d07'};
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  margin: 0;
`

export default SuccessHubCelebration
